module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/writable.js
// module id = 212
// module chunks = 0